export default __webpack_public_path__ + "files/176eb9fa7346ded3032f93a05f235c5a.svg";